module.exports = __webpack_public_path__ + "img/icon_5_26.d9aaece5.png";